import CommonBulletList from 'common/components/entities/BulletList'
import CommonText from 'common/components/entities/TextNew/ui/TextUi'
import { BulletListInterface } from 'common/types/entities/BulletListInterface'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { usePopupOpenerRef } from 'publisher/hooks/use-popup-opener-ref'
import React, { memo } from 'react'
import { useCalculateTypography } from 'src/publisher/shared/hooks/use-calculate-typography'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'
import { useDelay } from '../../hooks/useDelay'

interface NewBulletListProps {
  entity: BulletListInterface
}

const NewBulletList = ({ entity }: NewBulletListProps) => {
  const ref = usePopupOpenerRef()
  const isVisible = useDelay(entity.delay)

  const {
    text: { paragraphTextColor, paragraphBackgroundColor },
    links: {
      linkTextColor,
      linkHoveredBackgroundColor,
      linkPressedBackgroundColor,
    },
  } = useThemeColor()

  const {
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography({
    fontSize: entity.fontSize,
    mobileFontSize: entity.mobileFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    textAlign: entity.textAlign,
    mobileTextAlign: entity.mobileTextAlign,
    fontFamily: entity.fontFamily,
    mobileFontFamily: entity.mobileFontFamily,
    fontWeight: entity.fontWeight,
    mobileFontWeight: entity.mobileFontWeight,
    fontStyle: entity.fontStyle,
    mobileFontStyle: entity.mobileFontStyle,
  })

  return isVisible ? (
    <StyleWrapper
      mobileMargin={entity.mobileMargin}
      margin={entity.margin}
      appearance={entity.appearance}
    >
      <CommonBulletList
        verticalSpacing={entity.verticalSpacing}
        mobileVerticalSpacing={entity.mobileVerticalSpacing}
        listItemIconColor={entity.listItemIconColor}
        mobileListItemIconColor={entity.mobileListItemIconColor}
        listItemIconSize={entity.listItemIconSize}
        isEditing={false}
      >
        <CommonText
          id={entity.htmlAttrId}
          linkColor={linkTextColor}
          fontSize={calculatedFontSize.desktop}
          fontFamily={calculatedFontFamily.desktop}
          mobileFontFamily={calculatedFontFamily.mobile}
          mobileFontSize={calculatedFontSize.mobile}
          lineHeight={calculatedLineHeight.desktop}
          mobileLineHeight={calculatedLineHeight.mobile}
          color={entity.color || paragraphTextColor}
          padding={entity.padding}
          fontStyle={calculatedFontStyle.desktop}
          mobileFontStyle={calculatedFontStyle.mobile}
          fontWeight={calculatedFontWeight.desktop}
          mobileFontWeight={calculatedFontWeight.mobile}
          mobilePadding={entity.mobilePadding}
          textAlign={calculatedTextAlign.desktop}
          mobileTextAlign={calculatedTextAlign.mobile}
          backgroundColor={entity.backgroundColor || paragraphBackgroundColor}
          mobileBackgroundColor={
            entity.mobileBackgroundColor || paragraphBackgroundColor
          }
          linkHover={{ color: linkHoveredBackgroundColor }}
          linkActive={{ color: linkPressedBackgroundColor }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: entity.content || entity.html || '',
            }}
            ref={ref}
          />
        </CommonText>
      </CommonBulletList>
    </StyleWrapper>
  ) : (
    <div />
  )
}

export default memo(NewBulletList)
